import "core-js/modules/es6.number.constructor";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-edit-item"
  }, [_vm.item ? _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "pic"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.item.isTop == 1,
      expression: "item.isTop==1"
    }],
    staticClass: "top-tips"
  }), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: _vm.getLazyImg(_vm.item.attachUrl, '?imageView2/1/w/234/h/234/interlace/1/q/85/'),
      expression: "getLazyImg(item.attachUrl,'?imageView2/1/w/234/h/234/interlace/1/q/85/')"
    }]
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.item.timeText && _vm.showCountDown(_vm.item),
      expression: "item.timeText&&showCountDown(item)"
    }],
    staticClass: "time-status"
  }, [_c('div', {
    staticClass: "time-tips",
    domProps: {
      "innerHTML": _vm._s(_vm.item.timeText)
    }
  })])]), _c('div', {
    staticClass: "rt"
  }, [_c('div', {
    staticClass: "cr"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm.item.isActivity ? _c('p', [_vm._v(_vm._s(_vm.item.activityName))]) : _c('p', [_vm._v(_vm._s(_vm.item.goodsName))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.item.labelType == 1 || _vm.item.labelType == 2 || _vm.item.isSaleOut == 1 || Number(_vm.item.saleNum) > 0,
      expression: "item.labelType==1||item.labelType==2||item.isSaleOut==1||Number(item.saleNum)>0"
    }],
    staticClass: "tips-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.item.labelType == 1,
      expression: "item.labelType==1"
    }],
    staticClass: "tips-item hot"
  }, [_c('div', [_c('ycf-svg', {
    staticClass: "iconfont",
    attrs: {
      "icon-name": "home_tag_fire"
    }
  }), _vm._v("爆单")], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.item.labelType == 2,
      expression: "item.labelType==2"
    }],
    staticClass: "tips-item new"
  }, [_c('div', [_c('ycf-svg', {
    staticClass: "iconfont",
    attrs: {
      "icon-name": "tag_shangxin"
    }
  }), _vm._v("新单")], 1)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.item.isSaleOut == 1,
      expression: "item.isSaleOut==1"
    }],
    staticClass: "tips-item"
  }, [_c('div', [_vm._v("即将抢光")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: Number(_vm.item.saleNum) > 0,
      expression: "Number(item.saleNum)>0"
    }],
    staticClass: "tips-item"
  }, [_c('div', [_vm._v("已抢"), _c('strong', [_vm._v(_vm._s(_vm.item.saleNum))]), _vm._v("份")])])]), _c('div', {
    staticClass: "money"
  }, [_c('p', {
    staticClass: "price-spend",
    class: {
      'is-multi-spec': _vm.item.isMultiSpec
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.priceInt) + _vm._s(_vm.item.priceFloat))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: Number(_vm.item.marketPrice) > Number(_vm.item.minPrice),
      expression: "Number(item.marketPrice)>Number(item.minPrice)"
    }],
    staticClass: "market-price"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("_showMarketPrice")(_vm.item.marketPrice)))])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: Number(_vm.item.marketPrice || '') > Number(_vm.item.minPrice || '') && Number(_vm.item.discount) > 0,
      expression: "Number(item.marketPrice||'')>Number(item.minPrice||'')&&Number(item.discount)>0"
    }],
    staticClass: "discount"
  }, [_c('strong', [_vm._v(_vm._s(_vm.item.discount))]), _vm._v("折")])]), _vm.item.address ? _c('div', {
    staticClass: "address-tips"
  }, [_c('div', {
    staticClass: "splice"
  }, [_c('p', [_c('ycf-svg', {
    staticClass: "iconfont home_list_location_i",
    attrs: {
      "icon-name": "home_list_location_i"
    }
  }), _vm._v(_vm._s(_vm._f("_showAddress")(_vm.item.address)) + _vm._s(_vm._f("_showBusiness")(_vm.item.business)))], 1)]), _vm.item.distance ? _c('span', {
    staticClass: "tips-item distance"
  }, [_vm._v(_vm._s(_vm.item.distance))]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _c('div', {
    staticClass: "bottom-box"
  }, [_c('div', {
    staticClass: "remove-btn",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.remove();
      }
    }
  }), _c('div', {
    staticClass: "cr-btn"
  }, [_c('div', {
    staticClass: "set-top-btn",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toTop();
      }
    }
  }, [_vm._v(_vm._s(_vm._f("_showTopText")(_vm.item.isTop)))]), _c('div', {
    staticClass: "to-detail-btn",
    class: {
      'has-tips': _vm.item.isOpenMemberCommission
    }
  }, [_vm.item.commText && !_vm.inPreview ? _c('p', {
    staticClass: "price-earn",
    class: {
      'type-2': _vm.item.commType == 2
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.earnInt) + _vm._s(_vm.item.earnFloat))])]) : _c('p', {
    staticClass: "queue-btn"
  }, [_vm._v("立即抢购")]), _vm.item.isOpenMemberCommission && !_vm.inPreview ? _c('div', {
    staticClass: "lv-tips"
  }, [_vm._v("LV")]) : _vm._e()])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };